/* eslint-disable eslint-comments/disable-enable-pair */

/* eslint-disable hydrogen/prefer-image-component */
import imageUrlBuilder from '@sanity/image-url';
import {twMerge} from 'tailwind-merge';
import sanityConfig from '../../../sanity.config';

const BREAKPOINTS = [[640], [768], [1024], [1280], [1536]]; // px
const WINDOWS_WIDTH = [640, 1280, 1536]; // px

/**
 * A simple image component that wraps around `@sanity/image-url`
 */
export default function SanityImage(props: {
  [x: string]: any;
  alt?: string;
  crop?: any;
  dataset?: any;
  height?: any;
  hotspot?: any;
  disableFitCrop?: boolean;
  layout: 'fill' | 'responsive';
  objectFit?: any;
  options?: any;
  projectId?: any;
  quality?: 80 | undefined;
  sizes?: any;
  src: any;
  width?: any;
  className?: string;
  classNameImageWithoutHotspot?: string;
  breakpoints?: number[][];
  loading?: 'lazy' | 'eager';
}) {
  const {
    alt,
    // blurDataURL,
    // eslint-disable-next-line no-unused-vars
    crop,
    dataset = sanityConfig.dataset,
    projectId = sanityConfig.projectId,
    hotspot,
    layout,
    objectFit,
    // eslint-disable-next-line no-unused-vars
    options,
    // eslint-disable-next-line no-unused-vars
    quality = 80,
    // eslint-disable-next-line no-unused-vars
    sizes,
    src,
    className,
    classNameImageWithoutHotspot,
    breakpoints,
    loading,
    disableFitCrop = false,
    ...rest
  } = props;

  if (!dataset) {
    throw new Error('SanityImage is missing required "dataset" property.');
  }
  if (!projectId) {
    throw new Error('SanityImage is missing required "projectId" property.');
  }
  if (!src) {
    return null;
  }

  // Strip out blacklisted props
  delete rest?.['decoding'];
  delete rest?.['ref'];
  delete rest?.['srcSet'];
  delete rest?.['style'];

  let urlBuilder = imageUrlBuilder({projectId, dataset})
    .image({
      _ref: src,
    })
    .format('webp')
    .quality(80);

  if (!disableFitCrop) {
    urlBuilder = urlBuilder.fit('crop');
  }

  const urlDefault = urlBuilder.url();

  if (hotspot) {
    return (
      <img
        loading={loading ?? 'lazy'}
        style={{
          ...(layout === 'fill' && {
            bottom: 0,
            height: '100%',
            left: 0,
            objectFit,
            position: 'absolute',
            right: 0,
            top: 0,
            width: '100%',
          }),
          ...(layout === 'responsive' && {
            width: '100%',
          }),
        }}
        srcSet={(breakpoints || BREAKPOINTS)
          .map(
            (breakpoint) =>
              `${urlDefault}&fit=crop&crop=focalpoint&fp-x=${hotspot.x.toFixed(
                2,
              )}&fp-y=${hotspot.y.toFixed(2)}&w=${breakpoint[0]}${
                breakpoint?.[1] ? `&h=${breakpoint[1]}` : ''
              } ${breakpoint[0]}w`,
          )
          .join(', ')}
        sizes={`${(breakpoints || BREAKPOINTS)
          .map(
            (breakpoint, index) =>
              `(max-width: ${WINDOWS_WIDTH?.[index] ?? 1200}px) ${
                breakpoint[0]
              }px`,
          )
          .join(', ')}, ${(breakpoints || BREAKPOINTS)?.at(-1)?.[0]}px`}
        src={urlDefault}
        width={breakpoints?.at(-1)?.[0]}
        height={breakpoints?.at(-1)?.[1]}
        alt={alt}
      />
    );
  } else {
    return (
      <img
        loading={loading ?? 'lazy'}
        className={twMerge(
          'w-full h-full',
          className,
          classNameImageWithoutHotspot,
        )}
        src={urlBuilder.width(breakpoints?.at(-1)?.[0] ?? 1530).url()}
        srcSet={(breakpoints || BREAKPOINTS)
          .map(
            (breakpoint) =>
              `${urlDefault}&w=${breakpoint[0]}${
                breakpoint?.[1] ? `&h=${breakpoint[1]}` : ''
              } ${breakpoint[0]}w`,
          )
          .join(', ')}
        sizes={`${(breakpoints || BREAKPOINTS)
          .map(
            (breakpoint, index) =>
              `(max-width: ${WINDOWS_WIDTH?.[index] ?? 1200}px) ${
                breakpoint[0]
              }px`,
          )
          .join(', ')}, ${(breakpoints || BREAKPOINTS)?.at(-1)?.[0]}px`}
        width={breakpoints?.at(-1)?.[0]}
        height={breakpoints?.at(-1)?.[1]}
        alt={alt}
      />
    );
  }
}
